/**
 * Wave 355 · Goal + Plan schemas — strategic priority model.
 * Shape documented here; ships in 355.
 */

import { z } from 'zod';
import { idSchema, isoDateTimeSchema } from './common.js';

export const GoalDTOSchema = z.object({
  id: idSchema,
  projectId: idSchema,
  name: z.string(),
  metrics: z.array(z.string()).describe('KPI targets'),
  createdAt: isoDateTimeSchema,
});
export type GoalDTO = z.infer<typeof GoalDTOSchema>;

export const PlanDTOSchema = z.object({
  id: idSchema,
  goalId: idSchema,
  name: z.string(),
  milestones: z.array(z.unknown()),
  createdAt: isoDateTimeSchema,
});
export type PlanDTO = z.infer<typeof PlanDTOSchema>;
